export default {
  root: {
    class: [
      // Position and Overflow
      'relative overflow-hidden',

      // Shape and Size
      'h-5',

      // Colors
      'bg-surface-200 dark:bg-surface-700'
    ]
  },
  value: ({ props }) => ({
    class: [
      // Flexbox & Overflow & Position
      {
        'absolute flex items-center justify-center overflow-hidden':
          props.mode !== 'indeterminate'
      },

      // Colors
      'bg-primary',

      // Spacing & Sizing
      'm-0',
      { 'h-full': props.mode !== 'indeterminate' },

      // Transitions
      {
        'transition-[width] duration-1000 ease-in-out':
          props.mode !== 'indeterminate',
        'progressbar-value-animate': props.mode == 'indeterminate'
      },

      // Before & After (indeterminate)
      {
        'before:content-[\'\'] before:absolute before:top-0 before:bottom-0 before:bg-inherit before:will-change-[inset-inline-start,inset-inline-end] before:animate-progressbar-indeterminate before:animation-delay-2.1s':
          props.mode == 'indeterminate',
        'after:content-[\'\'] after:absolute after:top-0 after:bottom-0 after:bg-inherit after:will-change-[inset-inline-start,inset-inline-end] after:animate-progressbar-indeterminate-short after:animation-delay-2.1s':
          props.mode == 'indeterminate'
      }
    ]
  }),
  label: {
    class: [
      // Flexbox
      'inline-flex',

      // Font and Text
      'text-primary-contrast text-xs font-semibold'
    ]
  },
  keyframes: {
    'progressbar-indeterminate': {
      '0%': {
        'inset-inline-start': '-35%',
        'inset-inline-end': '100%'
      },
      '60%': {
        'inset-inline-start': '100%',
        'inset-inline-end': '-90%'
      },
      '100%': {
        'inset-inline-start': '100%',
        'inset-inline-end': '-90%'
      }
    },
    'progressbar-indeterminate-short': {
      '0%': {
        'inset-inline-start': '-200%',
        'inset-inline-end': '100%'
      },
      '60%': {
        'inset-inline-start': '107%',
        'inset-inline-end': '-8%'
      },
      '100%': {
        'inset-inline-start': '107%',
        'inset-inline-end': '-8%'
      }
    }
  }
}
